function YogaBenefits() {
  return (
    <section className="ftco-section">
      <div className="container">
        <div className="row justify-content-center mb-5 pb-3">
          <div className="col-md-12 heading-section ftco-animate text-center">
            <h2 className="mb-1">Benefits of Yoga</h2>
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center order-md-last">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-md-right pl-4 pl-md-0 pr-md-4">
                <h3>Balances Body &amp; Mind</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center order-md-last">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-md-right pl-4 pl-md-0 pr-md-4">
                <h3>Healthy Daily Life</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center order-md-last">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-md-right pl-4 pl-md-0 pr-md-4">
                <h3>Improves your flexibility</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center order-md-last">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-md-right pl-4 pl-md-0 pr-md-4">
                <h3>Protects your spine</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
          </div>

          <div className="col-md-4 d-flex">
            <div
              className="img img-services w-100"
              style={{
                backgroundImage:
                  'url(https://images.unsplash.com/photo-1556816723-1ce827b9cfbb?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=2783&q=80)',
              }}
            ></div>
          </div>

          <div className="col-md-4">
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center\">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-left pl-4">
                <h3>Betters your bone health</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center\">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-left pl-4">
                <h3>Increases your blood flow</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center\">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-left pl-4">
                <h3>Keep a practice journal</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
            <div className="services-2 ftco-animate d-flex w-100">
              <div className="icon d-flex justify-content-center align-items-center\">
                <span className="flaticon-meditation"></span>
              </div>
              <div className="text text-left pl-4">
                <h3>Builds muscle strength</h3>
                <p>
                  A small river named Duden flows by their place and supplies it
                  with the necessary regelialia.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default YogaBenefits
